export default __webpack_public_path__ + "static/media/dedicated.58ad281a.png";